<template>
  <UlDialog
    v-model="dialog"
    :title="$t('releaseNotes.title')"
    :buttons="buttons"
    header-type="information"
    content-class="release-notes-dialog"
  >
    <template #leftIcon>
      <Confetti event-name="playConfettiReleaseNotes" class="icon_56" />
    </template>
    <template #text>
      <div class="mb-8 mb-md-6 release-notes-perex" v-html="$t('releaseNotes.perex')"></div>
      <div class="grey-lighten rounded-lg pa-4 text-left">
        <div
          v-for="(noteContent, key) in notesContent"
          :key="key"
          :class="{
            'mt-6': key > 0
          }"
        >
          <div class="d-flex justify-start align-center">
            <div>
              <v-img
                contain
                width="48"
                height="48"
                :src="$asset(`img/icons/${noteContent.icon}.svg`)"
                class="mr-4"
              />
            </div>
            <div v-html="noteContent.text" />
          </div>
        </div>
      </div>
    </template>
  </UlDialog>
</template>

<script>
import releaseNotes from '@/mixins/releaseNotes';

export default {
  name: 'ReleaseNotesModal',
  mixins: [releaseNotes],
  computed: {
    notesContent() {
      return this.$t('releaseNotes.content');
    },
    dialog: {
      get() {
        return this.$store.state.profile.dashboard.dialog === 'releaseNotes';
      },
      set(value) {
        this.$store.commit('profile/dashboard/setDialog', value);
      }
    },
    buttons() {
      return [
        {
          events: {
            click: () => this.nextButtonAction()
          },
          text: this.$t('releaseNotes.primaryButtonText'),
          props: {
            color: 'grey-lighten',
            elevation: 0,
            class: 'release-btn-light'
          }
        },
        {
          events: {
            click: () => this.secondaryButtonAction()
          },
          text: this.$t('releaseNotes.secondaryButtonText')
        }
      ];
    }
  },
  watch: {
    dialog(newValue) {
      if (newValue) {
        this.gtmPush({ event: 'notification_show', 'notification.type': 'release' });
        this.updateReleaseNotes();

        setTimeout(() => {
          this.$eventHub.$emit('playConfettiReleaseNotes');
        }, 500);
      }
    }
  },
  mounted() {
    if (this.dialog) {
      this.updateReleaseNotes();
    }
  },
  methods: {
    nextButtonAction() {
      //notification.button must be same as button text
      this.gtmPush({
        event: 'notification_click',
        'notification.button': this.$t('releaseNotes.primaryButtonText'),
        'notification.type': 'release'
      });

      this.$router.push(this.$localePath('prevention'), () => (this.dialog = false));
    },
    secondaryButtonAction() {
      this.gtmPush({
        event: 'notification_click',
        'notification.button': this.$t('releaseNotes.secondaryButtonText'),
        'notification.type': 'release'
      });
      this.$router.push(
        this.$localePath({
          name: 'dashboard',
          query: { dfn: 'healthCheck', step: 1 }
        }),
        () => (this.dialog = false)
      );
    }
  }
};
</script>

<style>
.release-notes-perex {
  color: #757575;
  font-weight: 500;
  letter-spacing: 2%;
  max-width: 412px;
}
.release-notes-dialog .text-h2 {
  font-size: 24px !important;
  line-height: 1.2 !important;
}
.release-notes-dialog {
  max-height: 95% !important;
}
</style>
